import { Database, Q } from '@nozbe/watermelondb'

import { Chat } from '../model'

export const findChatByConnectionKeyAndPhoneNumber = async (
  connectionKey: string,
  phoneNumber: string,
  database: Database
): Promise<Chat | undefined> => {
  try {
    const chats = database.collections.get<Chat>('chats')
    return await database.read(async () => {
      const chatKey = `${connectionKey}.${phoneNumber}`
      const fetchChats = await chats.query(Q.where('key', Q.eq(chatKey))).fetch()
      return fetchChats.length > 0 ? fetchChats[0] : undefined
    })
  } catch (e) {
    console.error(e)
  }
}
